/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/core';
export var img = {
  name: "lfi4ce",
  styles: "width:71px;height:71px;"
};
export var ctaCard = {
  name: "19midj6",
  styles: "padding:16px;"
};